export default __webpack_public_path__ + "static/media/sign_in_background.bf9b4d98.jpg";